import React from "react";
import { Link, useParams } from "react-router-dom";
import ProjectsList from "./ProjectsList.json";

const ProjectNavigation = () => {
    const { handle } = useParams();

    const currentProjectIndex = ProjectsList.findIndex((project) => project.handle === handle);
    if (currentProjectIndex === -1) {
        return <p>Project not found</p>;
    }

    const nextIndex = currentProjectIndex - 1;
    const prevIndex = currentProjectIndex + 1;

    const nextProject = nextIndex >= 0 ? ProjectsList[nextIndex] : null;
    const prevProject = prevIndex < ProjectsList.length ? ProjectsList[prevIndex] : null;

    return (
        <section className="project-nav">
            <div className="container">
                <div className="project-nav-grid col-2">
                    <div>
                        {nextProject && (
                            <Link to={`/project/${nextProject.handle}`} className="project-nav-link">
                                <div>
                                    <p className="project-nav-title">{nextProject.title}</p>
                                    <p className="project-nav-subtitle">
                                        <i className="fas fa-chevron-left"></i> Next
                                    </p>
                                </div>
                            </Link>
                        )}
                    </div>
                    <div>
                        {prevProject && (
                            <Link to={`/project/${prevProject.handle}`} className="project-nav-link">
                                <div>
                                    <p className="project-nav-title">{prevProject.title}</p>
                                    <p className="project-nav-subtitle">
                                        Previous <i className="fas fa-chevron-right"></i>
                                    </p>
                                </div>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectNavigation;